import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import ProjectHome from './pages/Project/ProjectHome';
import SurveyHome from './pages/Survey/SurveyHome';
import SurveyDashboardHome from './pages/Survey/SurveyDashboardHome';
import RoleHome from './pages/Role/RoleHome';
import Projects from './pages/Project/Projects';
import ReportHome from './pages/Reports/ReportsHome';
import { Box } from '@mui/material';
import SettingsHome from './pages/Settings/SettingsHome';
import ProfileHome from './pages/Profile/ProfileHome';
import SurveyResponsePage from './pages/SurveyResponsePage';
import ProtectedRoute from './services/ProtectedRoute';
import Unauthorized from './services/Unauthorized';
import Chatbot from './components/ChatBot/chatbot';
import ClientHome from './pages/Clients/ClientHome';


function App() {
  const [isChatbotVisible, setIsChatbotVisible] = useState(false);

  const toggleChatbot = () => {
    setIsChatbotVisible((prev) => !prev);
  };

  return (
    <Router>
      <Box>
        <Routes>
          {/* Redirect root to login */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          {/* Standalone Login Route */}
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/surveypage/:uniqueId" element={<SurveyResponsePage />} />
          {/* Unauthorized Page */}
          <Route path="/unauthorized" element={<Unauthorized />} />
          {/* Shared Layout with Sidebar */}
          <Route path="/projects" element={<ProjectHome />}>
            <Route index element={<Projects />} />
          </Route>
          <Route path="/clients" element={<ClientHome />} />
          <Route path="/surveys" element={<SurveyHome />} />
          <Route path="/survey-dashboard" element={<SurveyDashboardHome />} />
          
          
          <Route
            path="/profile"
            element={<ProfileHome toggleChatbot={toggleChatbot} isChatbotVisible={isChatbotVisible} />}
          />
          {/* Protected Routes for Roles and Settings */}
          <Route
            path="/roles"
            element={
              <ProtectedRoute module="Roles" requiredAccess="Read/Write">
                <RoleHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/*"
            element={
              <ProtectedRoute module="Settings" requiredAccess="Read/Write">
                <SettingsHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute module="Reports" requiredAccess="Read/Write">
                <ReportHome />
              </ProtectedRoute>
            }
          />
        </Routes>
        {isChatbotVisible && <Chatbot />}
      </Box>
    </Router>
  );
}

export default App;